import React from 'react';
import { Link } from 'react-router-dom';
import TravelImg1 from '../../imgs/travel.jpg';
import TravelImg2 from '../../imgs/homepage.jpg';

const TravelRetreats: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Travel Retreats
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4">
            <img
            src={TravelImg1}
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <img
            src={TravelImg2}
            className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Practicing the Wim Hof Method and a Motiv8 Lifestyle outside of your normal environment can be a great way to 
          kickstart your practice or just a good way to have a fresh reset.  The basic premise is to go to really cool 
          places, with really cool people, and do really cool things. Only cool people apply!!
        </p>
        <div className="text-3xl font-bold text-darkgreentext leading-relaxed mt-16">
          Our Upcoming Motiv8 Retreat!
        </div>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Island Park, ID
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Retreat dates: June 13-15
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed mt-4'>
          Join Sean with fellow Wim Hof Method instructor, Noah Eubanks, who trained Sean in Poland for an Epic Wim Hof 
          Method weekend at Sean’s family cabin in Island Park, ID.  Space is limited!  The Wim Hof Method encourages being 
          comfortable and casual.  This will be a unique experience to live and learn the method in a very intimate family 
          cabin atmosphere.  Trip will be capped at 12 participants.
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed mt-8'>
          Pricing is according to sleeping arrangements:
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed mt-2'>
          Private room with a queen bed: $888 (Price for couple)
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          King bed in dormitory style cabin loft: $848 (Price for couple)
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Single bed in loft: $422
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Air mattress or bring your own sleeping pad: $388
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <Link to="/contact" className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition">
          Sign Up by Contacting Us Now!
        </Link>
      </div>
      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-2xl font-bold text-darkgreentext leading-relaxed">
          Events to Come
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Ireland
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          Island Park, ID
        </p>
        <p className='text-xl text-darkgreentext leading-relaxed'>
          China
        </p>
      </div>
    </div>
  );
};

export default TravelRetreats;
